import * as React from "react"

const MOBILE_BREAKPOINT = 768
// Phones in landscape are wider than the breakpoint but far too short for the
// desktop layout (a 240px sidebar, week grids): treat a short touch screen as
// mobile too, so the sidebar becomes a sheet and pages pick their phone views.
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px), (max-height: 480px) and (pointer: coarse)`

function subscribe(onChange: () => void) {
  const mql = window.matchMedia(QUERY)
  mql.addEventListener("change", onChange)
  return () => mql.removeEventListener("change", onChange)
}

function getSnapshot() {
  return window.matchMedia(QUERY).matches
}

function getServerSnapshot() {
  return false
}

export function useIsMobile() {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
